module.exports = " {{{dadosconteudo.conteudo}}} ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/home.vue
// module id = 200
// module chunks = 0